import store from '../store'
import {
  setErrorMessage
} from '../actions'

export const showToast = (msg, duration = '3000') => {  
  store.dispatch(setErrorMessage(msg))
  let toast = document.getElementsByClassName('toast')
  if(toast[0]){
    toast[0].style.display = 'block'
  } 
  if (window.toastTimeOut) {
    clearTimeout(window.toastTimeOut)
  }
  window.toastTimeOut = setTimeout(() => {
    try {
      toast[0].style.display = 'none'
    } catch (e) { }
  }, duration)
}
